.main {
    min-width: 300px;
}